<script>
import router from "@/router";

export default {
  name: "CommentsWrapper",
  props: {
    slicer: {
      default: Infinity,
    },
    commentType: {
      default: 'product',
      validator(value) {
        // The value must match one of these strings
        return ['brand', 'product', 'order', 'course', 'content', 'category'].includes(value)
      }
    },
    item_id: {
      default: ''
    }
  },
  data() {
    return {
      form: {
        id: this.item_id,
        type: this.commentType,
        page: 1
      },
      comments: [],
      paginationMeta: [],
    }
  },
  computed: {
    checkItemId() {
      return this.item_id != undefined
    }
  },
  methods: {
    async changePage(page) {
      this.form.page = page

      await this.initWrapper()

    },
    async setComments() {
      let response;
      this.form.id = this.item_id
      if (this.commentType !== 'product') {
        response = await this.$store.dispatch("Comment/getUserCommentsWithoutState", this.form);
      } else {
        response = await this.$store.dispatch('Comment/getProductCommentsWithoutState', this.form)
      }

      let data = response.data.data

      this.comments = data.data
      this.paginationMeta = data.meta
      this.$emit("comments", this.comments);
    },
    async initWrapper() {
      if (this.checkItemId) {
        await this.setComments()
      }
    }
  },
  render() {
    return this.$slots.default({
      comments: this.comments != undefined ? this.comments.slice(0, this.slicer) : [],
      pagination: this.paginationMeta,
      changePageFunction: this.changePage,
    });
  },
  async mounted() {
    await this.initWrapper();
  },
  watch: {
    // '$route': {
    //   handler: function () {
    //     this.initWrapper();
    //   },
    // },
    checkItemId: {
      handler: function () {
        this.initWrapper();
      },
    },
  }
}
</script>
